var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.845474,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB800",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19455 15.249C8.21832 15.0351 8.23021 14.9281 8.26257 14.8282C8.29129 14.7394 8.33186 14.655 8.38319 14.5772C8.44104 14.4895 8.51714 14.4134 8.66934 14.2612L15.5019 7.4286C16.0734 6.85713 16.9999 6.85713 17.5714 7.42861C18.1429 8.00008 18.1429 8.92662 17.5714 9.4981L10.7388 16.3307C10.5866 16.4829 10.5105 16.559 10.4228 16.6168C10.345 16.6681 10.2606 16.7087 10.1719 16.7374C10.0719 16.7698 9.96491 16.7817 9.75098 16.8054L8 17L8.19455 15.249Z",
    stroke: "#F2AE00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconCircle);
export default __webpack_public_path__ + "static/media/editIconCircle.680b7677f31a9dd4dbbbf6c5b30ba5a0.svg";
export { ForwardRef as ReactComponent };